// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.omnia-edit-multiple-croppings-confirmation-dialog .dialog-body {
  padding: 0;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section + section.section {
  border-top: 1px solid #ccc;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section.warning {
  background-color: #fcf8e3;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section h3.section-heading {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section > p {
  margin: 0;
  color: #666;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section ul {
  margin-bottom: 0;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section ul > li {
  margin-bottom: 5px;
}
.omnia-edit-multiple-croppings-confirmation-dialog .sections section.section ul > li .checkbox {
  margin-bottom: 0;
}
.omnia-edit-multiple-croppings-confirmation-dialog span.plan-label {
  display: flex;
  align-items: center;
  gap: 5px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
